// extracted by mini-css-extract-plugin
export default {"Guide":"Guide_Guide__QYLkX"};